module.exports = __webpack_public_path__ + "img/photo_hex_01.72afcdca.png";